<template>
    <div class="d-flex flex-row cover"
         data-toggle="tooltip"
         :title="title">
        <b-button class="h-100" variant="light" @click="decrease">
            <i class="fa-solid fa-caret-left"></i>
        </b-button>
        <span class="m-auto number">{{ number }}</span>
        <b-button class="h-100" variant="light" @click="increase">
            <i class="fa-solid fa-caret-right"></i>
        </b-button>
    </div>
</template>

<script>
export default {
    name: "WheelNumber",
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        title: String,
        value: {
            type: [String, Number],
            required: true
        },
        min: Number,
        max: Number,
    },
    data() {
        return {
            number: 0,
        }
    },
    watch: {
        value: {
            handler() {
                this.number = Number.parseInt(this.value);
                this.initNumber();
            },
            immediate: true
        }
    },
    methods: {
        initNumber() {
            if (this.max !== undefined && this.number > this.max) {
                this.number = this.max;
                this.emitUpdate();
            } else if (this.min !== undefined && this.number < this.min) {
                this.number = this.min;
                this.emitUpdate();
            }
        },
        increase() {
            if (this.max === undefined || this.number < this.max) {
                this.number += 1;
                this.emitUpdate();
            }
        },
        decrease() {
            if (this.min === undefined || this.number > this.min) {
                this.number -= 1;
                this.emitUpdate();
            }
        },
        emitUpdate() {
            this.$emit('update:value', this.number);
        },
    }
}
</script>

<style scoped>
.cover {
    border: 1px solid black;
    border-radius: 10%;
}

.number {
    font-weight: bold;
    font-size: 1rem;
}
</style>